var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { buildTitle, buildStandardMeta, buildOgMetaRefs, buildOgMeta, buildLink, } from '../../types/builders';
import adapter from './adapter-groups-post';
import { siteIDs } from '../../adapters/utils';
var IDs = adapter.IDs;
export var GROUPS_POST = {
    tags: __spreadArrays([
        buildTitle("{{" + IDs.POST_CONTENT_60 + "}} | {{" + IDs.GROUP_NAME + "}}"),
        buildStandardMeta('description', "{{" + IDs.POST_CONTENT_200 + "}}"),
        buildStandardMeta('robots', 'index')
    ], buildOgMetaRefs(), [
        buildOgMeta('og:image', "{{" + IDs.POST_IMAGE_URL + "}}"),
        buildOgMeta('og:image:width', "{{" + IDs.POST_IMAGE_WIDTH + "}}"),
        buildOgMeta('og:image:height', "{{" + IDs.POST_IMAGE_HEIGHT + "}}"),
        buildOgMeta('og:site_name', "{{" + siteIDs.SITE_NAME + "}}"),
        buildOgMeta('og:url', "{{" + IDs.POST_URL + "}}"),
        buildOgMeta('og:type', 'website'),
        buildLink('canonical', "{{" + IDs.POST_URL + "}}"),
        buildOgMeta('article:author', "{{" + IDs.POST_AUTHOR + "}}"),
        buildOgMeta('article:published_time', "{{" + IDs.POST_PUBLISH_DATE + "}}"),
        buildOgMeta('article:modified_time', "{{" + IDs.POST_MODIFIED_DATE + "}}"),
    ]),
};
